import { render } from "./profile-circle.svg?vue&type=template&id=f38e57e4?inline"
const script = {}
script.render = render

export default script